import { Droplet } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Logo({ dark = false, className = "", white = false }) {
  const { img } = useContent();
  const circle = img("logo_circle");
  const textLogo = white ? img("logo_white") || img("logo_text") : img("logo_text");

  return (
    <div className={`flex items-center gap-1.5 sm:gap-2.5 ${className}`} data-testid="brand-logo">
      {circle ? (
        <img src={circle} alt="ColorStone" className="h-7 w-7 rounded-full object-cover sm:h-10 sm:w-10" />
      ) : (
        <span className="relative flex h-7 w-7 items-center justify-center rounded-full bg-[#2563EB] sm:h-10 sm:w-10">
          <Droplet className="h-4 w-4 text-white sm:h-5 sm:w-5" fill="white" />
        </span>
      )}
      {textLogo ? (
        <img src={textLogo} alt="ColorStone" className="h-5 w-auto object-contain sm:h-6" />
      ) : (
        <span
          className={`font-heading text-xl font-extrabold tracking-tight ${
            dark ? "text-white" : "text-[#0F172A]"
          }`}
        >
          Color<span className="text-[#2563EB]">Stone</span>
        </span>
      )}
    </div>
  );
}
